import emailjs from '@emailjs/browser';
import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'; // Import faTimes for error icon

function ContactForm() {

      const form = useRef();
      const [successMessage, setSuccessMessage] = useState('');
      const [errorMessage, setErrorMessage] = useState(''); // State to track error message
    
      const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs
          .sendForm('service_dho9wqk', 'template_50whqex', form.current, {
            publicKey: 'WTzqKU23KBYYu87t8',
          })
          .then(
            () => {
              console.log('SUCCESS!');
              setSuccessMessage('Your message has been sent successfully!');
              setErrorMessage(''); // Clear any previous error message
              form.current.reset();
            },
            (error) => {
              console.log('FAILED...', error.text);
              setErrorMessage('Failed to send message. Please try again later.'); // Set error message
              setSuccessMessage(''); // Clear any previous success message
            },
          );
      };
  
      return (
        <>
          <form onSubmit={sendEmail} ref={form} className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48 border-t-2 border-l-2 border-b-2 rounded-lg border-lavender shadow-no-right">
                <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div>
                      <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900  font-paragraph">
                        First name
                      </label>
                      <div className="mt-2.5">
                        <input
                          type="text"
                          name="first-name"
                          id="first-name"
                          autoComplete="given-name"
                          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm  placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900 font-paragraph">
                        Last name
                      </label>
                      <div className="mt-2.5">
                        <input
                          type="text"
                          name="last-name"
                          id="last-name"
                          autoComplete="family-name"
                          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm  placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900 font-paragraph">
                        Email
                      </label>
                      <div className="mt-2.5">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          autoComplete="email"
                          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm  placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <label htmlFor="phone-number" className="block text-sm font-semibold leading-6 text-gray-900 font-paragraph">
                        Phone number
                      </label>
                      <div className="mt-2.5">
                        <input
                          type="tel"
                          name="phone-number"
                          id="phone-number"
                          autoComplete="tel"
                          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm  placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-2">
                      <label htmlFor="message" className="block text-sm font-semibold leading-6 text-gray-900 font-paragraph">
                        Message
                      </label>
                      <div className="mt-2.5">
                        <textarea
                          name="message"
                          id="message"
                          rows={4}
                          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm  placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          defaultValue={''}
                        />
                      </div>
                    </div>
                  </div>
                  {successMessage && <div className="success-message text-green-600 font-paragraph text-xs mt-2">{successMessage} <FontAwesomeIcon icon={faCheck} /></div>}
                  {errorMessage && <div className="error-message text-red-600 font-paragraph text-xs mt-2">{errorMessage} <FontAwesomeIcon icon={faTimes} /></div>}
                  <div className="mt-8 flex justify-end">
                    <button
                      type="submit"
                      className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 font-paragraph"
                    >
                      Send message
                    </button>
                  </div>
                </div>
              </form>
        </>
      )
    }
    
    export default ContactForm
